import { useEffect, useState } from "react";
import { getSectionToUserURL } from "../utils/ConstantsURL";

export const useFetchSections = (token, idDocument) => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let response = await fetch(getSectionToUserURL(idDocument), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        let data = await response.json();
        if (response.ok) {
          setSections(data);
          setLoading(false);
        } else {
          throw new Error(data.message);
        }
      } catch (error) {
        setLoading(false);
      }
    };

    fetchData();
  }, [token, idDocument]);

  return { sections, loading };
};
  